import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

if(document.getElementById('advisors-vue-app') != null) {
  new Vue({
    render: h => h(App),
  }).$mount('#advisors-vue-app')
}